import { SearchPredicate } from '@nx-smartmonkey/shared/domain';
import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';
import { Project } from '../../../domain/backoffice/project/Project';
import { ProjectsTableColumn } from '../tableColumns/projects';

export enum BackofficeProjectsActionType {
  SET_PROJECTS_TABLE_COLUMNS = `SET_PROJECTS_TABLE_COLUMNS`,
  SEARCH_PROJECTS_SUCCESS = `SEARCH_PROJECTS_SUCCESS`,
  SET_SEARCH_PROJECTS_PREDICATES = `SET_SEARCH_PROJECTS_PREDICATES`,
}

export interface SetProjectsTableColumnsAction {
  type: BackofficeProjectsActionType.SET_PROJECTS_TABLE_COLUMNS;
  payload: Array<ProjectsTableColumn>;
}

export interface SearchProjectsSuccessAction {
  type: BackofficeProjectsActionType.SEARCH_PROJECTS_SUCCESS;
  payload: {
    projects: PaginatedResult<Project>;
  };
}

export interface SetSearchProjectsPredicatesAction {
  type: BackofficeProjectsActionType.SET_SEARCH_PROJECTS_PREDICATES;
  payload: {
    predicates: Array<SearchPredicate>;
    predicatesBase64: string;
  };
}

export type BackofficeProjectsActions =
  | SetProjectsTableColumnsAction
  | SearchProjectsSuccessAction
  | SetSearchProjectsPredicatesAction;
